export default "__VITE_ASSET__Ewidp4xZ0S01RpmrEUMNYA__"